import { ACADEMY_LAUNCHED } from "@/lib/academy/launch";

// One navigation model keeps desktop and mobile destinations in sync.
export const SITE_NAVIGATION = [
  {
    id: "about",
    label: "About",
    items: [
      { id: "mission", href: "/#mission", label: "Mission" },
      { id: "why-now", href: "/#why-now", label: "Why Now" },
      { id: "founder", href: "/#founder", label: "Founder" },
      { id: "sustainability", href: "/sustainability", label: "Sustainability" },
    ],
  },
  {
    id: "explore",
    label: "Explore",
    items: [
      { id: "primer", href: "/explore#primer", label: "Primer" },
      { id: "ecosystem", href: "/explore#ecosystem", label: "Ecosystem" },
      { id: "audience", href: "/explore#audience", label: "Audience" },
    ],
  },
  {
    id: "opportunities",
    label: "Opportunities",
    items: [
      { id: "partners", href: "/#certified-partner", label: "Partners" },
      { id: "employers", href: "/careers#employers", label: "For Employers" },
      { id: "deck", href: "/decks", label: "Deck Library" },
      { id: "case-study", href: "/case-study", label: "Case Study" },
      { id: "get-involved", href: "/get-involved", label: "Get Involved" },
    ],
  },
  {
    id: "community",
    label: "Community",
    items: [
      { id: "events", href: "/#events", label: "Events" },
      { id: "jobs", href: "/#jobs", label: "Job Board" },
      { id: "my-jobs", href: "/my-jobs", label: "My Jobs" },
      { id: "careers", href: "/careers", label: "Careers Hub" },
      { id: "find-your-path", href: "/careers#find-your-path", label: "Find Your Path" },
      { id: "early-career", href: "/careers#early-career", label: "Early Career Jobs" },
      { id: "job-alerts", href: "/careers#alerts", label: "Job Alerts" },
      { id: "talent-in-tech", href: "/explore#talent-in-tech", label: "Talent in Tech" },
    ],
  },
  {
    id: "the-wire",
    label: "The Wire",
    items: [
      { id: "the-wire", href: "/wire", label: "DCYB Wire" },
      { id: "in-the-news", href: "/#news", label: "In The News" },
    ],
  },
  { id: "academy", href: "/academy", label: "Academy", wordmark: true, soon: !ACADEMY_LAUNCHED },
  { id: "market", href: "/#market", label: "Markets" },
];